<!-- 通知公告 -->
<template>
  <div class="notice-manage">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="通知内容"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.noticeContent"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="发布人"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.publishPerson"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="发布来源"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.publishOrgName"
                allowClear
              />
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item
              label="更新时间"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-range-picker
                format="YYYY-MM-DD HH:mm:ss"
                separator="~"
                allowClear
                :inputReadOnly="true"
                :value="dateValue"
                @change="onChange"
                :showTime="{
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }"
                :getCalendarContainer="(trigger) => trigger.parentNode"
              >
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="发布状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.publishStatus"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'publish_status' }"
              />
            </a-form-item>
          </a-col>
          <a-col class="flag" span="6" :offset="12">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts">
        <a-button type="primary" @click="handleTableRow(true)"
          ><a-icon type="plus" />新增</a-button
        >
      </div>
      <TableList
        :columns="columns"
        :tableData="tableData"
        :loading="loading"
        :pageInfo="pageBean"
        @getList="changePage"
      >
        <div slot="action" slot-scope="record" class="columns-action">
          <a-button
            type="link"
            @click="handleTableSee(true, record.scope)"
            >查看</a-button
          >
          <a-button
            type="link"
            @click="handleTableRow(true, record.scope, '2')"
            :disabled="record.scope.publishStatus == '1'"
            >编辑</a-button
          >
          <a-button type="link" @click="showSendConfirm(record.scope)">{{
            record.scope.publishStatus == "0" ? "发布" : "撤回"
          }}</a-button>
          <a-button
            type="link"
            @click="showDeletConfirm(record.scope)"
            :disabled="record.scope.publishStatus == '1'"
            >删除</a-button
          >
        </div>
      </TableList>
    </div>

    <AddEdit
      :modalFlag="modalFlag"
      :modalData="modalData"
      @handleFlag="handleTableRow"
      :modalType="modalType"
    />

    <Detail
      :modalFlag="modalDetailFlag"
      :modalData="modalData"
      @handleFlag="handleTableSee"
    />
  </div>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/logManage.js"; // 请求接口
import AddEdit from "./components/AddEdit.vue";
import Detail from "./components/Detail.vue";
import moment from "moment";

import "./index.less";

export default {
  components: {
    InputText,
    SelectModule,
    TableList,
    LenovoSelectModule,
    AddEdit,
    Detail
  },
  computed: {
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "通知内容",
          dataIndex: "noticeContent",
          key: "noticeContent",
          ellipsis: true,
          scopedSlots: { customRender: "noticeContent" },
        },
        {
          title: "发布人",
          dataIndex: "publishPerson",
          key: "publishPerson",
          ellipsis: true,
        },
        {
          title: "发布来源",
          dataIndex: "publishOrgName",
          key: "publishOrgName",
          ellipsis: true,
          scopedSlots: { customRender: "publishOrgName" },
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
          width: 190,
          ellipsis: true,
        },
        {
          title: "发布状态",
          dataIndex: "publishStatusDesc",
          key: "publishStatusDesc",
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 200,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        noticeContent: "",
        publishPerson: "",
        publishOrgName: "",
        publishStatus: "",
        publishStartTime: "",
        publishEndTime: "",
      },
      dateValue: [], // 日期
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      modalFlag: false, // 弹层状态
      modalData: {}, // 表格选中数据
      modalType: "", // 弹层类型
      modalDetailFlag: false, // 查看
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    moment,
    onChange(date, dateString) {
      this.dateValue = dateString;
    },
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
            publishStartTime:
              this.dateValue && this.dateValue.length > 0
                ? this.dateValue[0]
                : "",
            publishEndTime:
              this.dateValue && this.dateValue.length > 0
                ? this.dateValue[1]
                : "",
          },
        },
      };
      API.pageDrugMessageNotice(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        noticeContent: "",
        publishPerson: "",
        publishOrgName: "",
        publishStatus: "",
        publishStartTime: "",
        publishEndTime: "",
      };
      this.dateValue = [];
      this.handleSearch();
    },
    // 新增/编辑
    handleTableRow(flag, row, type, status) {
      this.modalFlag = flag;
      // this.textType = textType;
      this.modalData = row || {};
      this.modalType = type;
      if (status == "ok") {
        this.getData(1);
      }
    },
    // 查看
    handleTableSee(flag, row) {
      this.modalDetailFlag = flag;
      this.modalData = row || {};
    },
    // 删除
    showDeletConfirm(row) {
      let _this = this;
      this.$confirm({
        title: "是否确定删除当前的通知公告?",
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
              },
            },
          };
          API.deleteDrugMessageNotice(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success("删除成功");
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    // 发布/撤回
    showSendConfirm(row) {
      let _this = this;
      this.$confirm({
        title: `是否确定${
          row.publishStatus == "0" ? "发布" : "撤回"
        }当前的通知公告?`,
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
                publishStatus: row.publishStatus == "0" ? "1" : "0",
              },
            },
          };
          API.updateDrugMessageNoticeStatus(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success(
                `${row.publishStatus == "0" ? "发布" : "撤回"}成功`
              );
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
  },
};
</script>
